import { makeStyles, TextField } from '@material-ui/core';
import boletoUtils from '@mrmgomes/boleto-utils';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDebouncedEffect } from 'use-debounced-effect';

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070 !important',
      },
    },
  },
});

const CodigoBarrasInput = ({
  id,
  name,
  label,
  onChange,
  onBlur,
  className,
  fullWidth,
  disabled,
  autoFocus,
  value,
  required,
  error,
  onFocus,
  onNext,
  tipo,
  inputProps,
  borderRed = false,
}) => {
  const [codigoBarras, setCodigoBarras] = useState(value);

  const classes = useStyles();

  useDebouncedEffect(
    () => {
      const boleto = boletoUtils.validarBoleto(codigoBarras);

      if (boleto.sucesso) {
        if (!boleto.tipoBoleto.includes('CONVENIO')) {
          boleto.vencimento = moment(boleto.vencimento);
        } else {
          boleto.vencimento = moment(null);
        }
        onChange({ target: { id, value: boleto.linhaDigitavel } }, boleto);
      } else {
        onChange({ target: { id, value: codigoBarras } }, boleto);
      }
    },
    100,
    [codigoBarras]
  );

  const handleChange = (e) => {
    if (tipo === 'ean') {
      if (e.target.value.length > 50) {
        return;
      }
    }

    let codigo = e.target.value;
    if (codigo) {
      codigo = codigo.replace(/[^0-9]/g, '');
    }

    setCodigoBarras(codigo);
  };

  /*
   * Impede que o submit seja disparado com o leitor
   */
  const keyPressListener = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onNext();
    }
  };

  return (
    <TextField
      required={!!required}
      className={clsx(borderRed ? {} : classes.root, className)}
      id={`codigo-barras-input-${id}`}
      name={name}
      label={label}
      onChange={handleChange}
      onFocus={onFocus}
      onKeyDown={keyPressListener}
      onBlur={onBlur}
      value={codigoBarras}
      fullWidth={fullWidth}
      variant="outlined"
      error={!!error}
      helperText={error}
      InputLabelProps={{ shrink: true }}
      disabled={disabled}
      autoFocus={autoFocus}
      autoComplete="off"
      inputProps={{
        ...inputProps,
        autoComplete: 'off',
        maxLength: 54,
      }}
    />
  );
};

CodigoBarrasInput.defaultProps = {
  fullWidth: true,
  onFocus: () => {},
  onBlur: () => {},
  onNext: () => {},
  tipo: 'boleto',
};

CodigoBarrasInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  value: PropTypes.string,
  error: PropTypes.bool,
  onFocus: PropTypes.func,
  onNext: PropTypes.func,
  tipo: PropTypes.string,
};

export default CodigoBarrasInput;
